import { useGlobalStore } from "@/stores/globalStore";
import useApiHelpers from "./helpers";

const { getRequest } = useApiHelpers();

export default function useCustomerActions() {
  const globalStore = useGlobalStore();

  const fetchCustomerId = async () => {
    const res = await getRequest('/customerId');
    globalStore.setCustomerId(res.data.customerId);
    return res.data.customerId;
  };

  const fetchCustomerKycSharingInfo = async () => {
    const res = await getRequest('/getKycSharingPersonalDetails');
    return res.data;
  };

  const fetchCustomerAccountInfo = async () => {
    const res = await getRequest('/getCustomerAccountInfo');
    return res.data;
  };

  const fetchCustomerDetails = async () => {
    const res = await getRequest('/getCustomerDetails');
    return res.data;
  };

  const fillForm = (formValues, form, store) => {
    const values = Object.entries(formValues);
    values.forEach(([key, value]) => {
      if (!store.form[key]) {
        return;
      }
      if (key === 'country') {
        const countryName = globalStore.getCountryName(value);
        store.form[key].value = countryName;
        form.value[key] = countryName;
        return;
      }

      store.form[key].value = value;
      form.value[key] = value;
    });
  };

  return {
    fetchCustomerId,
    fetchCustomerAccountInfo,
    fetchCustomerDetails,
    fetchCustomerKycSharingInfo,
    fillForm,
  };
}
